export const normalizePersonPosition = (position: string): string[] => {
  return position.split(';').map((position) => position.trim())
}
